import React from 'react'
import { useTranslation } from 'react-i18next';
import styles from './StoreItemPurchaseModal.module.scss';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import polygonScanIcon from '../../../assets/icons/icon-polygon.png';

import GemsPouchModal from '../../../assets/imgs/store/gems_pouch_modal.png';
import TowerPhone from '../../../assets/imgs/store/tower_phone.png';
import TowerPhoneCompleted from '../../../assets/imgs/store/tower_phone_completed.png';
import IconProcessingArrow from '../../../assets/icons/store/processing_arrow.png';
import IconFailed from  '../../../assets/icons/store/icon_failed.png';
import IconCooldown from  '../../../assets/icons/store/icon_cooldown.png';

const StoreItemPurchaseModal = (props) => {
    const { completed, show, showSetter, title, modalType, description, buttonText, txnHash } = props.content || {};
    const [t] = useTranslation();

    const MODALTYPES = {
        PENDING: 'pending',
        SUCCESS: 'success',
        FAILED: 'failed',
    }

    const closeModal = () => {
        showSetter(false);
    };

    const renderViewOnPolygonScan = (
        txnHash &&
            <a href={`${process.env.REACT_APP_POLYGON_BLOCK_EXPLORER_URL}` + `tx/` + txnHash} target="_blank" rel="noopener noreferrer">
                <div className={styles.view_on_polygonscan}>
                    <div>
                        <img src={polygonScanIcon} className={styles.icon} alt="polygon" />
                    </div>
                    <div className={styles.text}>
                        {t('GIFT_VIEW_PROCESS_POLYSCAN_LINK_BTN')}
                    </div>
                </div>
            </a> 
    );

    const renderOkButton = (
        <Button variant="cdh-general-blue" className={styles.ok_btn} onClick={() => showSetter(false)}>{buttonText}</Button>
    );

    return (
        <>
            <Modal show={show} dialogClassName={styles.store_item_modal} contentClassName={styles.store_modal_body} onHide={closeModal} centered>
                <div className={styles.close_btn} onClick={closeModal}><FontAwesomeIcon icon={faTimes}/></div>
                <Modal.Header className={styles.store_item_modal_header}>
                    <div className={styles.modal_image_wrapper}>
                        {modalType === MODALTYPES['FAILED'] ? 
                            <div className={styles.failed_icon_wrapper}>
                                <img src={IconFailed} width="73px" height="68px" alt="store item" />
                            </div> :
                            modalType === MODALTYPES['PENDING'] ?
                                <div className={styles.failed_icon_wrapper}>
                                    <img src={IconCooldown} width="73px" alt="cooldown" />
                                </div> :
                                <>
                                    <div>
                                        <img src={GemsPouchModal} width="178px" height="122px" alt="Gems Pouch" />
                                    </div>
                                    <div>
                                        <img src={IconProcessingArrow} width="60px" height="15px" alt="Processing Arrow" />
                                    </div>
                                    <div>
                                        <img src={completed ? TowerPhoneCompleted : TowerPhone} width="106px" height="136px" alt="Tower Phone" />
                                    </div>
                                </>
                        }
                    </div>
                </Modal.Header>
                <Modal.Body className={styles.store_item_modal_body}>
                    <div className={styles.modal_title}>{title}</div>
                    <div className={styles.modal_description}>{description}</div>
                </Modal.Body>
                <Modal.Footer className={styles.store_item_modal_footer}>
                    {completed ? renderOkButton : renderViewOnPolygonScan}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export { StoreItemPurchaseModal }